import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import './strategy.scss';
const Strategy = () => {
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    projectWebsite: '',
    userName: '',
    targetAmount: '',
    telegramHandle: '',
    userEmail: '',
    blurb: '',
    source: '',
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get("utm_source");

    if (utmSource) {
      setFormData((prev) => ({ ...prev, source: utmSource }));

      document.cookie = `source=${utmSource}; path=/; max-age=${60 * 60 * 24 * 30}`;
    } else {

      const match = document.cookie.match(/(^| )source=([^;]+)/);
      if (match) {
        setFormData((prev) => ({ ...prev, source: match[2] }));
      }
    }
  }, []);

  const handleClose = () => setShow(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.userEmail.trim() || !/\S+@\S+\.\S+/.test(formData.userEmail)) {
      newErrors.userEmail = 'Email is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      let payload = {
        email: formData.userEmail,
        source: formData.source || 'direct',
      };

      if (formData.userName.trim()) payload.userName = formData.userName.trim();
      if (formData.projectWebsite.trim()) payload.projectWebsite = formData.projectWebsite.trim();
      if (formData.targetAmount && !isNaN(formData.targetAmount) && Number(formData.targetAmount) > 0) {
        payload.targetAmount = Number(formData.targetAmount);
      }
      if (formData.telegramHandle.trim()) payload.telegramHandle = formData.telegramHandle.trim();
      if (formData.blurb.trim()) payload.blurb = formData.blurb.trim();

      const response = await fetch('https://prodapi.gems.vip/temp/book-call', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.status === 201) {
        setShow(true);
        setFormData({
          projectWebsite: '',
          userName: '',
          targetAmount: '',
          telegramHandle: '',
          userEmail: '',
          blurb: '',
          source: formData.source,
        });
      } else {
        alert(result.message || 'Something went wrong!');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Server error, please try again later.');
    }
  };

  return (
    <>
      <section className='main_strategy' id='booking'>
        <div className='custom-container'>
          <div className='outer_strategy'>
            <div className='rightside'>
              <h4>Book Your <span>Strategy Call Now</span></h4>
              {/* <h5>Complete the form below to schedule your private consultation with our launch specialists.</h5> */}

              {/* Project Name + Project Website */}
              <div className='inputs_div'>

                <div className='w-100'>
                  <input
                    type="text"
                    name="projectWebsite"
                    placeholder='Project Website'
                    value={formData.projectWebsite}
                    onChange={handleChange}
                    style={errors.projectWebsite ? { border: "1px solid #FC4F52" } : {}}
                  />
                  {errors.projectWebsite && <p className="error">{errors.projectWebsite}</p>}
                </div>


                <div className='w-100'>
                  <input
                    type="text"
                    name="userName"
                    placeholder='Your Name'
                    value={formData.userName}
                    onChange={handleChange}
                    style={errors.userName ? { border: "1px solid #FC4F52" } : {}}
                  />
                  {errors.userName && <p className="error">{errors.userName}</p>}
                </div>


              </div>

              {/* Your Name + Target Raise Amount */}
              <div className='inputs_div'>

                <div className='w-100'>
                  <input
                    type="number"
                    name="targetAmount"
                    placeholder='Target Raise Amount'
                    value={formData.targetAmount}
                    onChange={handleChange}
                    style={errors.targetAmount ? { border: "1px solid #FC4F52" } : {}}
                  />
                  {errors.targetAmount && <p className="error">{errors.targetAmount}</p>}
                </div>
                <div className='w-100'>
                  <input
                    type="text"
                    name="telegramHandle"
                    placeholder='Telegram Handle'
                    value={formData.telegramHandle}
                    onChange={handleChange}
                  />
                  {errors.telegramHandle && <p className="error">{errors.telegramHandle}</p>}
                </div>
              </div>

              {/* Telegram Handle + Your Email */}
              <div className='inputs_div' style={{ gridTemplateColumns: "1fr" }}>

                <div className='w-100'>
                  <input
                    type="email"
                    name="userEmail"
                    placeholder='Your Email'
                    value={formData.userEmail}
                    onChange={handleChange}
                    style={errors.userEmail ? { border: "1px solid #FC4F52" } : {}}
                  />
                  {errors.userEmail && <p className="error">{errors.userEmail}</p>}
                </div>
              </div>

              {/* Blurb (optional) */}
              <div className='inputs_div' style={{ gridTemplateColumns: "1fr" }}>
                <div className='w-100'>
                  <textarea
                    name="blurb"
                    placeholder='Blurb (optional)'
                    value={formData.blurb}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <button onClick={handleSubmit}>Submit</button>

              <h6>
                *Limited slots available. We maintain a selective onboarding process to ensure maximum attention and results for each project.
              </h6>
            </div>
            <img src='\assets\diamond.png' className='img-fluid imgdaimond' style={{ maxWidth: "500px" }} />

          </div>
        </div>
      </section>
      <Modal className='success' show={show} onHide={handleClose} centered>
        <Modal.Header >
          <Modal.Title>Success <svg onClick={handleClose} className='cuuursor' xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
            <path d="M14.0092 18.603L8.69405 11.3137L3.75856 18.603H0L6.75782 8.61812L0.455583 0H4.29008L9.0737 6.568L13.5916 0H17.3122L12.6804 6.60596H9.11167L17.8437 18.603H14.0092Z" fill="#02171D" />
          </svg> </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='modal_Succes'>
            <svg xmlns="http://www.w3.org/2000/svg" width="81" height="80" viewBox="0 0 81 80" fill="none">
              <path d="M40.4997 77.8946C61.4284 77.8946 78.3945 60.9286 78.3945 39.9999C78.3945 19.0712 61.4284 2.10516 40.4997 2.10516C19.571 2.10516 2.60498 19.0712 2.60498 39.9999C2.60498 60.9286 19.571 77.8946 40.4997 77.8946Z" fill="#329879" />
              <path d="M36.6264 54.3998C36.0791 54.3998 35.5317 54.1893 35.1528 53.7682L23.4475 42.063C22.6054 41.2209 22.6054 39.9156 23.4475 39.0735C24.2896 38.2314 25.5949 38.2314 26.437 39.0735L36.5001 49.1366L54.5212 26.3998C55.237 25.4735 56.5843 25.3472 57.4685 26.063C58.3949 26.7788 58.5212 28.1261 57.8054 29.0103L38.3107 53.5998C37.9317 54.063 37.3843 54.3577 36.7949 54.3998C36.7107 54.3998 36.6686 54.3998 36.6264 54.3998Z" fill="#E2E9EC" />
            </svg>
            <h3>Your details have been submitted!</h3>
            <p>Our team will reach out soon</p>
            <button onClick={handleClose}>Close</button>
          </div>
        </Modal.Body>

      </Modal>
    </>

  )
}

export default Strategy
